type CounterStrikeVersion = 'cs-go' | 'cs-2';

interface BombRoundsConfig {
  round_group_size: number;
  overtime_size: number;
  change_side_on_ot: boolean;
}

const CS_ROUND_CONFIG: Record<CounterStrikeVersion, BombRoundsConfig> = {
  'cs-2': {
    round_group_size: 12,
    overtime_size: 6,
    change_side_on_ot: false
  },
  'cs-go': {
    round_group_size: 15,
    overtime_size: 6,
    change_side_on_ot: false
  }
};

const VALORANT_ROUNDS_CONFIG: BombRoundsConfig = {
  round_group_size: 12,
  overtime_size: 2,
  change_side_on_ot: true
};

const CS_FIRST_TO_TIMELINE: Record<CounterStrikeVersion, number[]> = {
  'cs-2': [3, 6, 9],
  'cs-go': [3, 5, 10, 13]
};

const LOL_PLAYERS_ROLE_ORDER: [
  LolPlayerRole,
  LolPlayerRole,
  LolPlayerRole,
  LolPlayerRole,
  LolPlayerRole
] = ['top', 'jun', 'mid', 'adc', 'sup'];
const DOTA2_PLAYERS_ROLE_ORDER = [1, 2, 3, 4, 5];

const GAME_LABEL_FOR_VIDEOGAME: { [key in VideogameSlug]: string } = {
  'league-of-legends': 'match_details-game',
  'cs-go': 'match_details-map',
  'dota-2': 'match_details-game',
  ow: 'match_details-game',
  rl: 'match_details-game',
  'cod-mw': 'match_details-game',
  'r6-siege': 'match_details-game',
  fifa: 'match_details-game',
  valorant: 'match_details-game',
  kog: 'match_details-game',
  'lol-wild-rift': 'match_details-game',
  'starcraft-2': 'match_details-game',
  'starcraft-brood-war': 'match_details-game',
  'e-soccer': 'match_details-game',
  'e-basketball': 'match_details-game',
  fortnite: 'match_details-game',
  pubg: 'match_details-game',
  'e-cricket': 'match_details-game',
  mlbb: 'match_details-game'
};

const VIDEOGAME_EVENT_LIST_ORDER: VideogameSlug[] = [
  'cs-go',
  'dota-2',
  'league-of-legends',
  'valorant'
];

const VIDEOGAMES_COVERAGE: Record<
  Subset<Coverage, 'next_game_live' | 'live_odds'>,
  VideogameSlug[]
> = {
  live_odds: [
    'league-of-legends',
    'cs-go',
    'dota-2',
    'ow',
    'rl',
    'valorant',
    'kog',
    'e-basketball',
    'e-soccer',
    'e-cricket',
    'mlbb'
  ],
  next_game_live: ['league-of-legends', 'dota-2', 'cs-go', 'valorant', 'kog', 'rl', 'mlbb']
};

const VIDEOGAMES_WITH_GRID_MODE: VideogameSlug[] = ['league-of-legends'];

const VIDEOGAMES_WITH_SCRAPER_SCOREBOARD: VideogameSlug[] = ['cs-go', 'dota-2'];

export {
  CS_ROUND_CONFIG,
  CS_FIRST_TO_TIMELINE,
  LOL_PLAYERS_ROLE_ORDER,
  DOTA2_PLAYERS_ROLE_ORDER,
  GAME_LABEL_FOR_VIDEOGAME,
  VIDEOGAME_EVENT_LIST_ORDER,
  VIDEOGAMES_COVERAGE,
  VALORANT_ROUNDS_CONFIG,
  VIDEOGAMES_WITH_GRID_MODE,
  VIDEOGAMES_WITH_SCRAPER_SCOREBOARD
};

export type { CounterStrikeVersion, BombRoundsConfig };
